<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
      <b-row>

      <b-col cols="10"></b-col>


        <b-col cols="2" >
          <b-button
              variant="outline-primary"
              size="sm"
              @click="agregarNuevo()"
          >
            Crear
            <b-icon icon="box-arrow-up-right" animation="throb" ></b-icon>
          </b-button>
        </b-col>
      </b-row>

      <b-row>
      <b-col cols="12">
        <b-table
            thead-tr-class="columnas"
            :items="listaAfiliaciones"
            :fields="campos"
            :per-page="$registrosPorPaginaTabla"
            :current-page="paginaActual"
            fixed
        >


          <template v-slot:cell(acciones)="row">
            <b-button-group>
              <b-button
                  title="Editar Afiliación"
                  size="sm"
                  variant="outline-warning"
                  @click="modificar(row.item)"
              ><em class="fa fa-pencil"></em>
              </b-button>
              <b-button
                  v-if="row.item.registroActivo === 'Inactivo'"
                  title="Activar registro"
                  variant="outline-success"
                  size="sm"
                  @click="cambiarEstatusAfiliacion(row.item)"
              ><em class="fa fa-undo"></em></b-button>
              <b-button v-else
                        title="Desactivar registro"
                        variant="outline-danger"
                        size="sm"
                        @click="cambiarEstatusAfiliacion(row.item)"
              >
                <b-icon icon="trash-fill"></b-icon>
              </b-button>
            </b-button-group>
          </template>

        </b-table>

        <b-spinner v-if="loader" ></b-spinner>
        <b-pagination
            v-model="paginaActual"
            align="center"
            :total-rows="listaAfiliaciones.length"
            :per-page="$registrosPorPaginaTabla"
            aria-controls="my-table1"
        ></b-pagination>
      </b-col>
      </b-row>


      <b-modal
          v-model="show"
          :title="tituloModal"
          size="lg"
          no-close-on-backdrop
          no-close-on-esc
      >

        <b-container fluid>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group align="left">
                  <label>Clínica
                    <validacion/>
                  </label>

                    <v-select  name="clinica" placeholder="Clinicas"
                              label="strNombre"
                              :reduce="(variable) => variable.idClinica"
                              :options="clinicas"
                               v-model="$v.afi.idClinica.$model"
                               :disabled="seModifica"
                    ></v-select>
                </b-form-group>
                <b-form-group align="left">
                  <label>Banco
                    <validacion/>
                  </label>
                  <v-select  name="banco" placeholder="Bancos"
                             label="nombre"
                             :reduce="(variable) => variable.idTerminal"
                             :options="bancos"
                             v-model="$v.afi.idTerminal.$model"
                             :disabled="seModifica"
                  ></v-select>
                </b-form-group>

                <b-form-group align="left">
                  <label>Nombre Terminal
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="cash-stack"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nombreTerminal" name="nombreTerminal" placeholder="Nombre Terminal"
                                  v-model="$v.afi.nombreTerminal.$model" type="text"
                                  :state="validateState('nombreTerminal')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group align="left">
                  <label>Afiliación
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="cash-stack"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="afiliacion" name="afiliacion" placeholder="Afiliación"
                                  v-model="$v.afi.afiliacion.$model" type="number"
                                  :state="validateState('afiliacion')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>

              </b-form>
            </b-col>
          </b-row>
        </b-container>



        <div slot="modal-footer">
          <b-button variant="outline-primary"
          @click="guardar()">
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
          </b-button>

        </div>
      </b-modal>


    </b-container>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
  name: "BancoAfiliacion",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    listaAfiliaciones:[],
    campos: [
      { key: "idClinica", label: "Id Clinica", sortable: true},
      { key: "clinica", label: "Clinica", sortable: true},
      { key: "idTerminal", label: "Id Banco", sortable: true },
      { key: "banco", label: "Banco", sortable: true },
      { key: "nombreTerminal", label: "Nombre Terminal", sortable: true },
      { key: "afiliacion", label: "Afiliación", sortable: true },
      { key: "registroActivo", label: "Estatus", sortable: true },
      { key: "acciones", label: "Acciones", sortable: true },
    ],
    paginaActual: 1,
    show: false,
    tituloModal: '',
    seModifica: false,
    loaderAcciones: false,
    loader: false,
    clinicas:[],
    bancos:[],

    afi: {
      idClinica: null,
      clinica: null,
      idTerminal: null,
      banco: null,
      afiliacion: null,
      nombreTerminal: null,
      registroActivo: null,
    },
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.traerListaAfiliaciones();
    this.obtenerClinicasYBancos();
  },
  validations() {
    return {
      afi: {
        idTerminal:{required},
        idClinica: {required},
        afiliacion: {required},
        nombreTerminal: {required},
      }
    }

  },
  methods: {
    traerListaAfiliaciones(){
      this.loader = true;
      this.listaAfiliaciones = [];
      const url = this.$api + "forma/afiliacion-Clinica";

      this.$http
          .get(url)
          .then((response) => {
            this.listaAfiliaciones = response.data.data;
          })
          .catch((err) => {
            this.errorMensaje(err);
            this.loader = false;
          })
          .finally(() => {
            this.loader = false;
          });
    },
    agregarNuevo() {

      this.seModifica = false;
      this.afi = {
            idClinica: null,
            idTerminal: null,
            afiliacion: null,
            nombreTerminal: null,
      },
      this.tituloModal = 'Agregar Afiliación';
      this.show = true;
    },

    modificar(item) {
      this.afi = item;
      this.tituloModal = 'Modificar Afiliación';
      this.show = true;
      this.seModifica = true;

    },

    guardar() {
      this.$v.afi.$touch();
      if (this.$v.afi.$anyError) {
        return;
      }
      this.loaderAcciones = true;

      this.$http.post(this.$api + 'forma/guardarAfiliacion', this.afi).then(respuesta => {
        if (respuesta.data.data) {

          this.show = false;
          this.traerListaAfiliaciones();
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: respuesta.data.data,
          })

        }
      }).catch((error) => {
            this.show = false;
            this.traerListaAfiliaciones();
        this.loaderAcciones = false;
        console.error(error);
      })
          .finally(() => {
            this.show = false;
            this.traerListaAfiliaciones();
                this.loaderAcciones = false;
              });

    },

    cambiarEstatusAfiliacion(afiliacion) {
      const url = this.$api + "forma/cambiarEstatus-Afiliacion";
      const parametros = {
        idClinicaBanco: afiliacion.idClinicaBanco,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };

      this.$http
          .put(url, parametros)
          .then((response) => {
            if (response.status === 200) {
              this.$swal({
                icon: "success",
                text: "Datos guardados correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            }
          })
          .catch((err) => {
            this.errorEnvio(err);
          })
          .finally(() => {
            this.cargando = true;
            this.traerListaAfiliaciones();
          });
    },
    obtenerClinicasYBancos() {
      this.$http.get(this.$api + 'catalogos/listaClinicas').then(respuesta => {
        if (respuesta.data.data) {
          this.clinicas = respuesta.data.data;
        }
      })

      this.$http
          .get(this.$api + "catalogos/listaBancos")
          .then((res) => {
            if (res.data.data) {
              this.bancos = res.data.data;
            }
          });
    },



    validateState(name) {
      const {$dirty, $error} = this.$v.afi[name];
      return $dirty ? !$error : null;
    },

  }
}
</script>

<style scoped>

</style>